import React from "react"
import { WeeklySchedule } from "../../../../../../supplier/admin/merchant/merchants/supplierMerchantsTypes"
import { Box, Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"
import { LocalizedEnum, LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { getScheduleWithDefaults } from "./helpers/getScheduleWithDefaults"

const useStyles = makeStyles()(() => ({
    timeBoxWrapper: {
        display: "flex",
        justifyContent: "space-between",
    },
    asideTimeText: {
        fontSize: ".875rem",
    },
}))

export const OpeningHoursAside = ({ weeklyScheduleData }: { weeklyScheduleData: WeeklySchedule[] }) => {
    const { classes } = useStyles()

    const scheduleWithDefaults = getScheduleWithDefaults(weeklyScheduleData)

    return (
        <Stack direction="column" spacing={1}>
            {Object.entries(scheduleWithDefaults).map(([day, hours]) => (
                <Box key={day} className={classes.timeBoxWrapper}>
                    <LocalizedEnum base="merchant-update-account-opening-hours-day" enumValue={day}>
                        <Typography className={classes.asideTimeText}>{day}</Typography>
                    </LocalizedEnum>
                    {hours.open === "closed" ? (
                        <LocalizedStrict id="merchant-update-account-opening-hours-dialog-closed">
                            <Typography className={classes.asideTimeText}>Closed</Typography>
                        </LocalizedStrict>
                    ) : (
                        <Typography className={classes.asideTimeText}>
                            {hours.open} - {hours.close}
                        </Typography>
                    )}
                </Box>
            ))}
        </Stack>
    )
}
